import { render, staticRenderFns } from "./ConfiguratorPage.vue?vue&type=template&id=c0398e46&scoped=true&"
import script from "./ConfiguratorPage.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorPage.vue?vue&type=style&index=0&id=c0398e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0398e46",
  null
  
)

export default component.exports